import useFeatureFlag from '../useFeatureFlag';

export function useConferenceOrderNotifications() {
  return useFeatureFlag('APP3156_Manage_Conference_Order_Emails', false);
}
